export default __webpack_public_path__ + "static/media/photo--sm--mike2.051b1544.jpg";